import styled from 'styled-components/macro';
import { FlexColumn, FlexJustifyBetween } from '../../../../../shared-styles/flex';

export const CommentContent = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  column-gap: ${(props) => props.theme.spacing(10)};
  border-top: 1px solid ${(props) => props.theme.palette.darkGray[25]};
  padding: ${(props) => props.theme.spacing(10)} ${(props) => props.theme.spacing(20)};
`;

export const AuthorLabel = styled.p`
  color: ${(props) => props.theme.palette.darkBlue[100]};
  margin-bottom: ${(props) => props.theme.spacing(12)};
  text-align: right;
`;

export const CreatedAtLabel = styled.p`
  color: ${(props) => props.theme.palette.gray[100]};
  text-align: right;
`;

export const CommentInfo = styled.div`
  ${FlexJustifyBetween}
  ${FlexColumn};
`;
